/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { EventName, IEventEmitterListener } from '../types';

import eventEmitter from './EventEmitter';
import { getDispatcher } from '@soluto-private/mx-analytics';

const { dispatchEvent } = eventEmitter;

const registerToEvents = (listener: IEventEmitterListener) => {
    const mxDispatcher = getDispatcher({ packageName: 'ae-sdk' });

    Object.values(EventName).map((event) =>
        listener.on(event, (detail) => {
            dispatchEvent(new CustomEvent(event, { detail }));
            mxDispatcher.dispatch(`OneService_Mx_AeSdk_${event}`);
        })
    );

    listener.on(EventName.SessionChanged, ({ sessionId }) =>
        mxDispatcher.dispatch('OneService_Mx_AeSdk_Session_Started', {
            ExtraData: { AeSdkSessionId: sessionId },
        })
    );
};

export default registerToEvents;
